import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { ApiResponse } from '@classes/api-response';
import { Settings } from '@models/settings';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private baseUrl = `${environment.base_url}/settings`;
  dutyAmount = 50;

  constructor(private http: HttpClient) {}

  loadSettings(): Observable<Settings> {
    return this.http.get<ApiResponse<Settings>>(this.baseUrl).pipe(
      map((res) => new Settings(res.settings)),
      tap((settings) => {
        this.dutyAmount = settings.dutyAmount;
      })
    );
  }

  updateDutyAmount(dutyAmount: number): Observable<Settings> {
    const body = JSON.stringify({ dutyAmount });
    return this.http.put<ApiResponse<Settings>>(`${this.baseUrl}/duty`, body).pipe(
      map((res) => new Settings(res.settings)),
      tap((settings) => {
        this.dutyAmount = settings.dutyAmount;
      })
    );
  }

  getRetailPlusDuty(retail: number | string): number {
    let value = typeof retail === 'string' ? parseFloat(retail.replace(/,/g, '')) : retail;
    value = isNaN(value) ? 0 : value;
    return value + this.dutyAmount;
  }
}
